import React, { Component } from 'react';
import { ajaxWrapper } from 'functions';
import { Wrapper } from 'library';
import settings from 'base/settings.js';

import {
    FormWithChildren,
    If,
    TextInput,
    Alert,
    Header,
    Button,
} from 'library';

class PasswordResetRequest extends Component {
    static component_name = 'PasswordResetRequest';
    constructor(props) {
        super(props);
        this.state = { email: '', error: false, sent: false, loaded: true };

        this.config = {
            form_components: [],
            can_have_children: true,
        };

        this.userLookup = this.userLookup.bind(this);
        this.emailCallback = this.emailCallback.bind(this);
        this.email = this.email.bind(this);

        this.setGlobalState = this.setGlobalState.bind(this);
    }

    userLookup() {
        ajaxWrapper(
            'POST',
            '/users/userCheck/',
            { email: this.state.email },
            this.email,
        );
    }

    setGlobalState(name, state) {
        this.setState(state);
    }

    email(result) {
        console.log('EMAIL', result);
        if (result.length > 0) {
            var user = result[0]['user'];
            ajaxWrapper(
                'POST',
                '/users/reset_password_request/',
                {
                    email: this.state.email,
                },
                this.emailCallback,
            );
        } else {
            this.setState({ error: true });
        }
    }

    emailCallback(result) {
        if ('error' in result) {
            this.setState({ error: true });
        } else {
            console.log('Email Sent');
            this.setState({ sent: true });
        }
    }

    render() {
        var content = (
            <div className="container">
                <Header
                    size={2}
                    text={
                        "Add your email and we'll send you a link to reset your password."
                    }
                />
                <FormWithChildren
                    autoSetGlobalState={true}
                    setGlobalState={this.setGlobalState}
                    globalStateName={'form'}
                >
                    {this.props.children}
                </FormWithChildren>
                <Button
                    type={'success'}
                    text={'Reset Password'}
                    onClick={this.userLookup}
                />
                <If logic={[[true, this.state.sent]]}>
                    <Alert
                        text={'Your password reset email has been sent.'}
                        type={'success'}
                    />
                </If>
                <If logic={[['exists', this.state.error]]}>
                    <Alert
                        text={'No user found with that email.'}
                        type={'danger'}
                    />
                </If>
            </div>
        );

        return <Wrapper loaded={this.state.loaded} content={content} />;
    }
}
export default PasswordResetRequest;
